import type { CartSuggestionCardsPreviewProduct } from './cart-suggestion-cards-block.config';
import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

/** Serializable product row used in CB2 upselling modal preview scenarios. */
export type UpsellingModalPreviewProduct = CartSuggestionCardsPreviewProduct;

/**
 * Serializable preview VM for `UpsellingModalComponent`.
 * Title, description, products and per-card button labels come from the
 * upselling rule, not from content-builder props.
 */
export type UpsellingModalScenarioContent = {
  title: string;
  description: string;
  products: readonly UpsellingModalPreviewProduct[];
  /** Button label keyed by product id. An empty label hides the button. */
  proposalLabels: Readonly<Record<string, string>>;
};

export const UPSELLINGMODAL_LEGACY_FIELD_ORDER = [];

const {
  upsellingModalDescriptor: _generatedUpsellingModalDescriptor,
  upsellingModalModalDefinition,
  upsellingModalDashboardLayout,
  upsellingModalConfig,
  upsellingModalResolveConfig,
  upsellingModalProperties,
  upsellingModalDefinitionSetupScenarios,
} = doodModalConfig(
  {
    name: "Upselling modal",
    handle: "upselling-modal",
    internal_name: "UpsellingModal",
    componentType: 'UpsellingModalComponent',
    category: 'modal',
    description: "Upselling modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "upselling-modal",
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function upsellingModalDescriptor(): IBlockDescriptor;
export function upsellingModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function upsellingModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedUpsellingModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedUpsellingModalDescriptor, upsellingModalProperties, fieldOrder);
}

export {
  upsellingModalModalDefinition,
  upsellingModalDashboardLayout,
  upsellingModalProperties,
  upsellingModalConfig,
  upsellingModalResolveConfig,
  upsellingModalDefinitionSetupScenarios,
};

export type UpsellingModalConfig = typeof upsellingModalConfig;
